import { useState, useEffect } from "react";
import { useGetModePaginationQuery } from "src/services/ModeServices";

const useModes = () => {
  const [modes, setModes] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetModePaginationQuery({
    limit: 10,
    searchValue: '',
    params: ["modeName", "modeDescription", "isVirtual"],
    page: 0,
    filterBy: [],
    dateFilter: {},
    orderBy: "createdAt",
    orderByValue: -1,
    isPaginationRequired: false,
  });

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setModes(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { modes, isDataLoading };
};

export default useModes;
